<template>
    <form class="secondary-c">
        <!-- Huddle password warning -->
        <div class="tw-flex tw-items-center tw-flex-col tw-p-8 tw-rounded-lg tw-bg-gray-0 tw-mb-4">
            <img class="tw-mb-3" src="/img/huddle-logo-yellow.png" style="max-width: 100px;">
            <p class="tw-text-gray-400 tw-leading-relaxed tw-font-semibold tw-text-center">
                {{ $t('profile.community_uses_huddle', [['community', settings.title]]) }}
                <br />
                {{ $t('profile.password_change_for_all_huddles') }}
            </p>
        </div>

        <div class="tw-flex">
            <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.password')" icon="fa fa-user">
                <form-input v-model="passwordfield1" name="passwordfield1" type="password"></form-input>
            </edit-input>
            <edit-input class="tw-w-full" :label="$t('fields.retype_password')" icon="fa fa-user">
                <form-input v-model="passwordfield1_confirmation" name="passwordfield1_confirmation" type="password">
                </form-input>
            </edit-input>
        </div>
        <div v-if="error" class="tw-text-red-500 tw-font-bold tw-my-4">{{ error }}</div>

        <div @click="updatePassword" class="general-button">{{ $t('fields.save') }} </div>
    </form>
</template>

<script>
import EditInput from '../EditInput.vue';
import Global from '../../../mixins/Global'
import Notification from '@/resources/assets/js/vue/lib/models/Notification';
import axios from 'axios';
export default {
    name: 'PasswordTab',
    mixins: [Global],

    components: {
        'edit-input': EditInput,
    },
    props: ['settings'],
    data() {
        return {
            passwordfield1: '',
            passwordfield1_confirmation: '',
            error: '',
        }
    },
    methods: {
        updatePassword() {
            if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$.,/!;|><`§±~:{}()'"[\]%*+\-_=#?&])[A-Za-z\d@$.,/!;|><`§±~:{}()'"[\]%*+\-_=#?&]{8,}$/.test(this.passwordfield1)) {
                this.error = this.$t('validation.minimum_password_strength');
                return;
            }
            if (this.passwordfield1 !== this.passwordfield1_confirmation) {
                this.error = this.$t('profile.password_doesnt_match');
                return;
            }
            this.error = '';
            axios.put('/api/v3/profile/update-password', {
                passwordfield1: this.passwordfield1,
                passwordfield1_confirmation: this.passwordfield1_confirmation
            }).then(() => {
                this.passwordfield1 = '';
                this.passwordfield1_confirmation = '';
                Notification.insert({
                    data: [
                        {
                            title: this.$t('profile.password_is_changed'),
                        },
                    ],
                });
            }).catch(() => {
                this.passwordfield1 = '';
                this.passwordfield1_confirmation = '';
                Notification.insert({
                    data: [
                        {
                            status: 'error',
                            title: this.$t('profile.password_changed_error'),
                        },
                    ],
                });
            });
        }
    },
}
</script> 
